export default __webpack_public_path__ + "static/media/RELEASE_BLOCKS_ICON_ORANGE.681a903d.svg";